import { heatItems } from "@/mocks/homeMocks";

export default function HeatRank() {
  return (
    <section id="heat" className="w-full">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">
        {/* 标题 */}
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs tracking-[0.28em] text-foreground-500">
              <span className="inline-block h-px w-8 bg-primary-400"></span>
              吃瓜热度榜
            </p>
            <h2 className="font-heading mt-3 text-2xl md:text-4xl font-black tracking-tight text-foreground-950">
              近 48 小时，谁在被反复求证
            </h2>
          </div>
          <span className="flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
            每 6 小时按核验进度刷新
          </span>
        </div>

        {/* 榜单列表 */}
        <div className="mt-8 flex flex-col divide-y divide-background-200">
          {heatItems.map((it) => (
            <a
              key={it.rank}
              href="#archive"
              className="group grid cursor-pointer grid-cols-1 gap-2 py-5 transition-colors sm:grid-cols-[3.5rem_1fr_auto] sm:items-baseline sm:gap-4"
            >
              <span className="font-heading text-2xl font-black leading-none text-background-300 transition-colors group-hover:text-primary-400 md:text-3xl">
                {it.rank}
              </span>
              <div>
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                  {it.title}
                </h3>
                <p className="mt-1.5 text-xs leading-6 text-foreground-500 md:text-sm">
                  {it.summary}
                </p>
              </div>
              <span className="flex items-center gap-2 sm:justify-end">
                <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-800">
                  {it.delta}
                </span>
                <i
                  className="ri-arrow-right-line hidden text-foreground-300 transition-all group-hover:translate-x-1 group-hover:text-primary-500 sm:block"
                  aria-hidden="true"
                ></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}